import { useState, useEffect, useRef } from 'react'

/**
 * 要素の表示状態を監視する。
 */
export const useWatchElementVisibility = (
  options?: Omit<IntersectionObserverInit, 'threshold'>,
) => {
  // nullは初期値を表す
  const [isVisible, setIsVisible] = useState<boolean | null>(null)
  const elementRef = useRef(null)

  const rootMargin = options?.rootMargin
  const root = options?.root

  useEffect(() => {
    const handleIntersection: IntersectionObserverCallback = (entries) => {
      entries.forEach((entry) => {
        // 要素が画面内に表示されているかどうかを判定
        setIsVisible(entry.isIntersecting)
      })
    }

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: [0], // 0で要素が少しでも表示されていれば判定
      root,
      rootMargin,
    })

    const currentRef = elementRef.current

    if (currentRef) {
      observer.observe(currentRef)
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef)
      }
    }
  }, [root, rootMargin])

  return { isVisible, elementRef }
}
